import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export interface IDiscounts {
  campaign_id: number;
  accrued_total: number;
  amount_to_pay: number;
  discount_amount: number;
  discount_purpose: 'loan' | 'extension';
  is_priority: boolean;
  maturity_date_by_plan: string;
  valid_days_count: number;
}

export interface IDiscountsStore {
  discounts: IDiscounts[];
}

const initialState: IDiscountsStore = {
  discounts: [],
};

export const regSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    updateDiscounts: (state, action) => {
      state.discounts = action.payload.discounts;
    },
  },
});

export const { updateDiscounts } = regSlice.actions;

export const selectDiscount = (state: RootState) => state.discounts;

export default regSlice.reducer;
